import { MessageCircle, Phone } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { C, COMPANY } from "@/data/content";

export default function FloatingButtons() {
    const { L } = useLanguage();
    const waHref = `${COMPANY.waHref}?text=${encodeURIComponent(
        L(C.contact.waPrefill)
    )}`;

    return (
        <div className="fixed bottom-5 start-5 z-40 flex flex-col gap-3">
            <a
                href={waHref}
                target="_blank"
                rel="noreferrer"
                data-testid="floating-whatsapp-button"
                aria-label="WhatsApp"
                title="WhatsApp"
                className="relative grid size-14 place-items-center rounded-full bg-[#25D366] text-[#06230F] shadow-lg shadow-black/40 transition-transform hover:scale-105"
            >
                <span className="pulse-node absolute inset-0 rounded-full bg-[#25D366]/50" />
                <MessageCircle className="relative size-6" />
            </a>
            <a
                href={COMPANY.telHref}
                data-testid="floating-call-button"
                aria-label={L(C.contact.callCta)}
                title={L(C.contact.callCta)}
                className="grid size-14 place-items-center rounded-full border border-gold-line-strong bg-ink-3/90 text-brass backdrop-blur transition-transform hover:scale-105"
            >
                <Phone className="size-6" />
            </a>
        </div>
    );
}
